import React from 'react'
import styled from 'styled-components'
import NewsItem from '../../molecules/NewsItem/NewsItem'
import Header from '../../atoms/Header/Header'

const Style = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 50px;
  margin-bottom: 64px;
  flex-wrap: wrap;
  justify-content: center;
  padding: 0 32px 50px;
`

const News = ({ data, title }) => {
  const displayed = []
  return (
    <div>
      <Header
        as="h3"
        display={3}
        style={{
          fontSize: '28px',
          color: '#162941',
          textTransform: 'capitalize'
        }}
      >
        Learn more about {title}
      </Header>
      <Style className="md:!grid grid-cols-2">
        {data.map((item) => {
          if (displayed.includes(item.title)) return null
          displayed.push(item.title)
          return (
            <NewsItem
              containerClassName="w-full"
              title={item.title}
              link={item.link}
              description={item.description}
              shadowless
              key={item.title}
              news={true}
              newsData={title}
            />
          )
        })}
      </Style>
    </div>
  )
}

export default News
